import {
    FileCheck2, BookOpenCheck, ScanLine, MessageSquareText,
    Globe2, Newspaper, QrCode, CalendarClock,
} from "lucide-react";
import { FEATURES } from "@/data/site";
import Reveal from "@/components/ui/reveal";

const ICONS = {
    FileCheck2, BookOpenCheck, ScanLine, MessageSquareText,
    Globe2, Newspaper, QrCode, CalendarClock,
};

function SectionHeading({ eyebrow, title, sub }) {
    return (
        <div className="max-w-2xl">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">{eyebrow}</p>
            <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">{title}</h2>
            {sub && <p className="mt-4 text-lg text-muted-foreground">{sub}</p>}
        </div>
    );
}

export default function Features() {
    return (
        <section id="funkcje" className="border-t border-border py-20 lg:py-28">
            <div className="container-gr">
                <SectionHeading
                    eyebrow="Funkcje"
                    title="Wszystko, czego potrzebuje JDG. W jednej aplikacji."
                    sub="Osiem narzędzi, które automatyzują Twoją księgowość — od faktur po podatki."
                />
                <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {FEATURES.map((f, i) => {
                        const Icon = ICONS[f.icon];
                        return (
                            <Reveal
                                key={f.id}
                                delay={(i % 3) * 0.06}
                                className={`group rounded-2xl border border-border bg-card p-6 transition-transform duration-300 hover:-translate-y-1 ${f.span || ""}`}
                            >
                                <div data-testid={`feature-card-${f.id}`}>
                                    <div className="grid h-12 w-12 place-items-center rounded-xl bg-gr-secondary text-gr-primary transition-colors group-hover:bg-gr-primary group-hover:text-white dark:bg-gr-dsecondary dark:text-gr-dprimary">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <h3 className="mt-5 text-xl tracking-tight text-foreground">{f.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
